export default __webpack_public_path__ + "static/media/courtyard_2k.caa593c3.hdr";